import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import {
  netWorthCardTitle,
  assetsString,
  liabilitiesString,
  assetsValueString,
  liabilitiesValueString,
} from './constants';

const NetWorthCard = ({ isVisible = true }) => {
  return (
    <Card
      sx={{
        maxWidth: { xs: 160, md: 225 },
        minHeight: { xs: 140, md: 160 },
        backgroundColor: 'black',
        color: 'white',
        borderRadius: '12px',
        boxShadow: 3,
        display: isVisible ? 'flex' : 'none',
      }}
    >
      <CardContent>
        {/* Title */}
        <Typography sx={{ fontSize: { xs: 12, sm: 16 } }} fontWeight="bold" gutterBottom>
          {netWorthCardTitle}
        </Typography>

        {/* Row for Assets and Line Chart */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {/* Assets Text */}
          <Box>
            <Typography
              variant="body2"
              sx={{
                textTransform: 'uppercase',
                fontSize: { xs: 8, md: 10 },
                m: 0.5,
                color: '#727272',
              }}
            >
              {assetsString}
            </Typography>
            <Typography variant="h5" sx={{ fontSize: { xs: 12, md: 16 } }}>
              {assetsValueString}
            </Typography>
          </Box>

          {/* Line Chart */}
          <Box
            sx={{
              width: '50%',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <svg
              viewBox="0 0 100 40"
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: '100%', height: '100%' }}
            >
              <polyline
                fill="none"
                stroke="#00FFB3"
                strokeWidth="2"
                points="0,30 20,20 40,25 60,15 80,20 100,10"
              />
            </svg>
          </Box>
        </Box>

        {/* Row for Liabilities and Bar Chart */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {/* Liabilities Text */}
          <Box>
            <Typography
              variant="body2"
              sx={{
                textTransform: 'uppercase',
                fontSize: { xs: 8, md: 10 },
                color: '#727272',
                m: 0.5,
              }}
            >
              {liabilitiesString}
            </Typography>
            <Typography variant="h5" sx={{ fontSize: { xs: 12, md: 16 } }}>
              {liabilitiesValueString}
            </Typography>
          </Box>

          {/* Bar Chart */}
          <Box
            sx={{
              width: '50%',
              height: '40px',
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                width: '6px',
                height: '10px',
                backgroundColor: '#FFEB3B',
                borderRadius: '2px',
              }}
            />
            <Box
              sx={{
                width: '6px',
                height: '20px',
                backgroundColor: '#FFEB3B',
                borderRadius: '2px',
              }}
            />
            <Box
              sx={{
                width: '6px',
                height: '25px',
                backgroundColor: '#FFEB3B',
                borderRadius: '2px',
              }}
            />
            <Box
              sx={{
                width: '6px',
                height: '30px',
                backgroundColor: '#FFEB3B',
                borderRadius: '2px',
              }}
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default NetWorthCard;
